import React, { useEffect, useState } from "react";
import "../HomeWork.css";
import AllQuestions from "../Completed/QuestionCompleted/AllQuestions";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import FilterNotFound from "../Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../../SubjectIcon";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function Completed({ setHomeMain, filter }) {
  const [completed, setCompleted] = useState({
    questionCompleted: false,
    homeworkId: null,
  });
  const navigate = useNavigate()
  const [completedCard, setCompletedCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [noContentClick, setNoContentClick] = useState(false);

  useEffect(() => {
    const completedBox = async () => {
      try {
        let response = await axios.get(
          `/homework/filterByStudentId/${currentUser?.id}/completed?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
          `${filter?.date
            ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
            : ``
          }` +
          `${filter?.time ? `&time=${filter?.time}` : ``}` +
          `${filter?.subjectId?.length !== 0
            ? `&subjectId=${filter?.subjectId}`
            : ``
          }`
        );

        response && setCompletedCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    completedBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setCompleted({
      ...completed,
      questionCompleted: false,
    });
  };
  return (
    <div>
      {completedCard && completedCard.length > 0 ? (
        <div>
          <div className="d-flex gap-4 mt-3 flex-wrap">
            {completedCard?.map((item, index) => (
              // <div
              //   className="containerForPendinDeatail p-3 "
              //   onClick={(e) => {
              //     setCompleted({
              //       ...completed,
              //       questionCompleted: true,
              //       homeworkId: item?.id,
              //     });
              //   }}
              //   key={index}
              // >
              //   <div className="kannadaHeader">{item?.subject_id?.name}</div>
              //   <div className="headingOfHW mt-2">{item?.name}</div>
              //   <span className="deadline">Deadline</span> &nbsp;
              //   <span className="deadlineDate">
              //     {timeHelper(item?.deadline)}
              //   </span>
              // </div>
              <div
                key={index}
                // className="summarySubBoxContainerHW"
                className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                style={{
                  borderTop: `8px solid #${item?.subject_id?.subject_color}`,
                }}
                onClick={(e) => {
                  // setCompleted({
                  //   ...completed,
                  //   questionCompleted: true,
                  //   homeworkId: item?.id,
                  // });
                  navigate(`/completedHomework`, { state: { homeworkId: item?.id } })
                }}
              >
                <div
                  className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                >
                  <div>
                    <div className="subboxSubjectName">
                      {item?.subject_id?.name}
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${SubjectIcon?.find(
                        (i) => i.subjectName === item?.subject_id?.name
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="SubsummarySubBoxContainer"
                  style={{ paddingTop: "0" }}
                >
                  <div className="headingOfHW" title={item?.name}>
                    <Tooltip
                      title={item?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <span className="sbj flex">
                        <BookText size={16} className="me-2 mt-1 text-dark" />
                        {shortenParagraph(item?.name, 25)}
                      </span>
                    </Tooltip>
                  </div>
                  <div className="flex mt-2">
                    <CalendarDays size={16} className="me-2 text-dark" />
                    <span className="deadline">Submitted: </span> &nbsp;
                    <span className="deadlineDate">
                      {timeHelper(item?.submitted_on)}
                    </span>
                  </div>
                  <span
                    style={{
                      color: "#FF0000",
                      fontSize: "16px",
                      fontWeight: "600",
                      textAlign: "right",
                      display: "block",
                    }}
                  >
                    {moment(item?.deadline).format("YYYY-MM-DD") < moment(item?.submitted_on).format("YYYY-MM-DD")
                      ? "Delayed Submission"
                      : " "}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* {completed.questionCompleted && (
            <AllQuestions
              handleQuestionfalse={handleQuestionfalse}
              homeworkId={completed?.homeworkId}
            />
          )} */}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      )
        : (<span >Homework Not Found</span>
          // : noContentClick ? (
          //   <span>Homework Not Found</span>
          // ) : (
          //   <FilterNotFound setNoContentClick={setNoContentClick} />
        )}
    </div>
  );
}
